<script setup lang="ts">
import type { Property } from '~/core/entities/property';

import { grammarInflection } from '~~/utils';

import IconMaterialSymbolsLightImageOutline from '~icons/material-symbols-light/image-outline';
import IconMaterialSymbolsLightMapOutline from '~icons/material-symbols-light/map-outline';
import IconMaterialSymbolsPlayArrowOutline from '~icons/material-symbols-light/play-arrow-outline';

import PropertyHeroActionButton from './ActionButton.vue';

interface PropertyHeroActionButtonsProps {
	property: Property | null;
	numberOfImages: number;
	numberOfVideos: number;
	shouldShowSimilarPropertyCta: boolean;
}

interface PropertyHeroActionButtonsEmits {
	'photo-clicked': [];
	'video-clicked': [];
	'map-clicked': [];
	'similar-clicked': [];
}

defineProps<PropertyHeroActionButtonsProps>();
defineEmits<PropertyHeroActionButtonsEmits>();
</script>

<template>
	<div
		class="no-scrollbar absolute inset-x-0 bottom-4 z-20 flex w-full items-center justify-start gap-2 overflow-x-auto px-4 md:bottom-5 md:w-fit md:overflow-x-hidden md:px-5 lg:bottom-6 lg:gap-3 lg:px-12"
	>
		<PropertyHeroActionButton @click="$emit('photo-clicked')">
			<IconMaterialSymbolsLightImageOutline class="size-5 text-white" />
			<slot name="photo-modal-cta-text" />
		</PropertyHeroActionButton>

		<PropertyHeroActionButton
			v-if="numberOfVideos"
			@click="$emit('video-clicked')"
		>
			<IconMaterialSymbolsPlayArrowOutline class="size-5 text-white" />
			{{ numberOfVideos }}
			{{ grammarInflection(numberOfVideos, 'vídeo', 'vídeos') }}
		</PropertyHeroActionButton>

		<PropertyHeroActionButton @click="$emit('map-clicked')">
			<IconMaterialSymbolsLightMapOutline class="size-5 text-white" />
			Mapa
		</PropertyHeroActionButton>

		<PropertyHeroActionButton
			v-if="shouldShowSimilarPropertyCta"
			@click="$emit('similar-clicked')"
		>
			<IconPilarHouseCheck class="size-5 text-white" />
			Semelhantes
		</PropertyHeroActionButton>
	</div>
</template>
